import { render, staticRenderFns } from "./ReportPageV2.vue?vue&type=template&id=1cdea7a6&scoped=true&"
import script from "./ReportPageV2.vue?vue&type=script&lang=js&"
export * from "./ReportPageV2.vue?vue&type=script&lang=js&"
import style0 from "./ReportPageV2.vue?vue&type=style&index=0&id=1cdea7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdea7a6",
  null
  
)

export default component.exports